import React, { Component, lazy } from "react";
import { connect } from "react-redux";
import { fetchDashboardList, fetchSystemWidgetsList } from "../../../actions/dashboardAction";

// import { setInitialFilterRefineValues } from "../../../actions/dashboardAction";

const LoadableDashboardPage = lazy(() => import("./DashboardPage"));

class ResearchPage extends Component {
    state = {};

    componentDidMount() {
        this.props.fetchSystemWidgetsList();

        // let filterRefineFilter = {
        //     sentiment: ["all"],
        //     sentimentType: "all",
        //     media: "all",
        //     postType: "all",
        //     sampling: "100",
        //     channel: "all",
        //     exclusion: "yes",
        // };
        // this.props.setInitialFilterRefineValues(filterRefineFilter);
    }

    render() {
        return <LoadableDashboardPage {...this.props} dashboardPageType="research" />;
    }
}

const mapDispatchToProps = (dispatch) => ({
    // setInitialFilterRefineValues: (arg) => dispatch(setInitialFilterRefineValues(arg)),
    fetchSystemWidgetsList: () => dispatch(fetchSystemWidgetsList()),
});

export default connect(null, mapDispatchToProps)(ResearchPage);
